import * as Availability from "@olga-food/schemas/lib/classes/schemas/catalog/Availability";
import { Builder } from "@olga-food/schemas/lib/classes/schemas/catalog/Builder";

export class Catalog {
  static executeOnSchema(item, callback) {
    for (let field of [
      "items",
      "extra_ingredients",
      "edges",
      "doughs",
      "sizes",
    ]) {
      if (item[field] && item[field].length > 0) {
        for (let children of item[field]) {
          Catalog.executeOnSchema(children, callback);
          callback(children, item, field);
        }
      }
    }
  }

  static buildId(item) {
    const hashes = [];

    const sortedSizes = (item.sizes || [])
      .filter((size) => size.sku)
      .sort((a, b) => String(a.sku).localeCompare(b.sku));

    sortedSizes.forEach((size) => {
      hashes.push(`S${size.sku}`);
    });

    if (item.sku) {
      hashes.push(`P${item.sku}`);
    }

    return hashes.join(":");
  }

  static hash(item) {
    let itemKeys = item.sku ? [item.sku] : [];

    Catalog.executeOnSchema(item, (children) => {
      if (children.sku) {
        itemKeys.push(children.sku);
      }
    });

    return itemKeys.join(":");
  }

  static updateCatalogAvailability(currentCatalog = []) {
    if (!Array.isArray(currentCatalog)) return [];

    return currentCatalog.map((category) => {
      const available =
        !!category.show && Availability.isAvailable(category, null, -3);

      const products = category.items.map((product) => ({
        ...product,
        available:
          !!product.show && Availability.isAvailable(product, null, -3),
      }));

      const hasActiveProducts = products.some((product) => product.available);

      return {
        ...category,
        available: available && hasActiveProducts,
        items: products,
      };
    });
  }

  static removeHiddensAndASized(catalog) {
    //Removendo do cardapio tudo o que está oculto
    Builder.executeOnSchema(catalog, (item) => {
      item.sizes = item.sizes?.filter((s) => s.show);
      item.items = item.items?.filter((i) => i.show);
      item.edges = item.edges?.filter((e) => e.show);
      item.doughs = item.doughs?.filter((d) => d.show);
      item.extra_ingredients = item.extra_ingredients?.filter((e) => e.show);
    });

    //Removendo do cardapio tudo que não tenha tamanho definido
    Builder.executeOnSchema(catalog, (item) => {
      if (["category", "option"].includes(item.type)) {
        return;
      }

      if (item.sizes?.length == 0) {
        item.show = false;
      }
    });

    return catalog;
  }
}
